module.exports = __webpack_public_path__ + "fonts/element-icons.da1319c.woff";